import React from "react";
import CustomTooltip from "common/tooltip";
import { currencyValue } from "utils/common";
import { storeCard } from "../storeCard";
export const displayMobileRowItem = (row, item, parentComponent) => {
  if (row && item && item.dataKey && row[item.dataKey]) {
    if (
      item &&
      item.name &&
      (item.name === "Unit Price" ||
        item.name === "Extended Price" ||
        item.name === "Sales Tax" ||
        item.name === "Total" ||
        item.name === "Old Price" ||
        item.name === "Updated Price")
    ) {
      return currencyValue(row[item.dataKey]);
    } else if (item.name === "salesNumber" && !item.dataKey && !row[item.dataKey]) {
      return "N/A";
    } else {
      return row[item.dataKey];
    }
  }

  if (item && item.keyName && item.keyName === "Store No") {
    return (
      <CustomTooltip
        placement="top"
        trigger="click"
        text={storeCard(
          row[item.valueName],
          row[item.nm],
          row[item.addr],
          row[item.city],
          row[item.st],
          row[item.zip],
          formatPhone(row[item.phone]),
          row[item.contact],
          row[item.verificationTime],
        )}
      >
        {verifiedState(row[item.verificationTime])}
        {row[item.valueName]}
      </CustomTooltip>
    );
  } else if (item && item.keyName && item.keyName === "Approval Status") {
    return (
      <CustomTooltip
        placement="top"
        trigger="click"
        text={
          <StatusCard
            approvalStatus={row[item.valueName]}
            laborBillRate={currencyValue(
              row[item.valueName] === "PENDING" || row[item.valueName] === "REJECTED"
                ? row[item.laborRateNew]
                : row[item.laborBillRate],
            )}
            installerPayRate={currencyValue(
              row[item.valueName] === "PENDING" || row[item.valueName] === "REJECTED"
                ? row[item.installerRateNew]
                : row[item.installerPayRate],
            )}
            percentReturn={formatPercentReturn(
              row[item.valueName] === "PENDING" || row[item.valueName] === "REJECTED"
                ? row[item.laborRateNew]
                : row[item.laborBillRate],
              row[item.valueName] === "PENDING" || row[item.valueName] === "REJECTED"
                ? row[item.installerRateNew]
                : row[item.installerPayRate],
            )}
          />
        }
      >
        {row[item.valueName]}
      </CustomTooltip>
    );
  } else if (
    item &&
    item.keyName &&
    item.keyName === "Labor Code" &&
    parentComponent &&
    parentComponent !== "bulkUpdateLabor"
  ) {
    return (
      <CustomTooltip
        placement="top"
        trigger="click"
        text={`${row[item.valueName1]}- ${row[item.valueName2]}: ${row[item.valueName3]}`}
      >
        {`${row[item.valueName1]}- ${row[item.valueName2]}`}
      </CustomTooltip>
    );
  } else if (item && item.keyName && item.keyName === "Product Name") {
    return (
      <CustomTooltip placement="top" trigger="click" text={row[item.valueName]}>
        {row[item.valueName]}
      </CustomTooltip>
    );
  } else if (
    item &&
    item.keyName &&
    item.keyName === "Description" &&
    parentComponent &&
    parentComponent === "bulkUpdateLabor"
  ) {
    return (
      <CustomTooltip placement="top" trigger="click" text={row[item.valueName]}>
        {row[item.valueName]}
      </CustomTooltip>
    );
  } else if (
    item &&
    item.keyName &&
    (item.keyName === "Bill Rates($)" ||
      item.keyName === "Installer Pay Rate" ||
      item.keyName === "New Bill Rates($)" ||
      item.keyName === "New Installer Pay Rate" ||
      item.keyName === "Updated Price" ||
      item.keyName === "Old Price")
  ) {
    return currencyValue(row[item.valueName]);
  } else if (item.valueName && row[item.valueName]) {
    return row[item.valueName];
  } else {
    return "";
  }
};
